import DataTable from "datatables.net-react";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Select from 'react-select';
import { ProfitLossPercentageServices } from "../../services/ProfitLossPercentageServices";
import * as BullCache from "../../util/BullCache";
import AdminDropdown from '../components/AdminDropdown';
import BrokerDropdown from '../components/BrokerDropdown';
import ClientDropdown from '../components/ClientDropdown';
import { customStyles, the } from "../components/customStyles";
import MasterDropdown from '../components/MasterDropdown';

function Profitlosspercentage(){
 const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  // const [selectedBroker, setSelectedBroker] = useState(null);
   const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
   const [selectedClient, setSelectedClient] = useState(null);
     const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [selectedValan, setSelectedValan] = useState('');
  const [valanDates, setValanDates] = useState([]);

  

  var user = BullCache.getFromCache("user");

  var allScripts = BullCache.getFromCache('allScripts');
  
  const handleSelectedClientChange = (selected) => {
    setSelectedClient(selected?.userId); 
  };

  const handleValanDateChange = (selectedOption) => {
    setSelectedValan(selectedOption ? selectedOption.value : ''); 
  };
   const options = valanDates.map(valan => ({
      value: valan,  
      label: valan
    }));
  
    useEffect(() => {
      ProfitLossPercentageServices.valanDates().then(res => {
        if (res.code === 1) {
          if (res.data.valandates.length > 0) {
            setValanDates(res.data.valandates);
          }
        }
      });
    }, []);
  
    return(   
        <div className="container-fluid">    
        <Card className="mt-2">
          <Card.Body>
              <Row>
               <Col sm={2} xs={6}>
               <b style={{fontSize:12}}>VALAN</b>
               <Select
                options={options}        
                value={options.find(option => option.value === selectedValan)} 
                onChange={handleValanDateChange} 
                placeholder="Select"
                styles={customStyles}
                theme={the} 
                isClearable  
                className=" text-black"
            />
                </Col>
                { user.adminType == 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?                 
                <Col sm={2} xs={6} className=''>
                     <b className="fss-05">ADMIN</b>
                      <AdminDropdown
                        adminId={user.adminId}  
                        setSelectedOption={setSelectedAdmin} />
                    </Col>                   
                    : ""
                  }
                    <Col sm={2} xs={6} className=''>
                    <b className="fss-05">MASTER</b>
                      <MasterDropdown
                        adminId={user.adminId}
                        selectedAdmin={selectedAdmin}
                        setSelectedOption={setSelectedMaster}
                        setSelectedMaster={setSelectedMaster}
                        setSelectedBrokerId={setSelectedBrokerId}
                       
                      />
                    </Col>
                    <Col sm={2} xs={6} className=''>
                    <b className="fss-05">BROKER</b>
                      <BrokerDropdown
                        selectedAdmin={selectedAdmin}
                        selectedMaster={selectedMaster}
                        setSelectedOption={setSelectedBrokerId}
                        setSelectedBrokerId={setSelectedBrokerId}
                        setSelectedSubBrokerId={setSelectedSubBrokerId}
                      />
                    </Col>
                    <Col sm={2} xs={6} className=''>
                <b className="fss-05">CLIENT</b>
                  <ClientDropdown
                    selectedAdmin={selectedAdmin}
                    selectedMaster={selectedMaster}
                    selectedBrokerId={selectedBrokerId}
                    setSelectedOption={handleSelectedClientChange} 
                  />

                </Col>

                <Col sm={3} xl={2} xs={6} className="mt-4">
                   <Button variant="success" size="sm" className="w-auto me-1">
                      Search
                   </Button>
                   <Button variant="secondary" size="sm" className="w-auto">
                      CSV
                   </Button>
                </Col>            
              </Row>
          </Card.Body>
        </Card>

        <Card className="mt-2">
          <Card.Body>
              <DataTable className=' striped bordered'>
                      <thead>
                        <tr>
                          <th className='bg-secondary ' style={{fontSize:12}}>USER</th>
                          <th className='bg-secondary ' style={{fontSize:12}}>PERCENTAGE PROFIT</th>
                          <th className='bg-secondary ' style={{fontSize:12}}>MARGIN USED</th>
                          <th className='bg-secondary ' style={{fontSize:12}}>NET PNL</th>
                          </tr>
                      </thead>
                     
                    </DataTable>
          </Card.Body>
        </Card>
   </div>
    )
}
export default Profitlosspercentage;